<template>
  <div class="dynamic-container">
    <div class="w1300 wapper">
      <div class="dynamic-header">
        <h2>学术动态</h2>
      </div>

      <div class="dynamic-tabs">
        <div class="tab-item" :class="{ active: activeTab === index }" v-for="(tab, index) in tabList" :key="index" @click="switchTab(index)">
          {{ tab.name }}
        </div>
      </div>

      <div v-if="activeTab === 0" class="tab-content">
        <!-- 工具栏：总数 + 搜索 + 排序 -->
        <div class="article-toolbar">
          <p class="total" v-if="newlist.length > 0 && !newloading">
            共 <span>{{ total }}</span> 条最新文章
          </p>
          <p class="total placeholder" v-else></p>
          <div class="toolbar-right">
            <el-input v-model="keyword" placeholder="搜索标题、作者、DOI、摘要..." clearable size="small" class="search-input" @keyup.enter.native="onSearch" @clear="onSearch">
              <el-button slot="append" icon="el-icon-search" @click="onSearch"></el-button>
            </el-input>
            <el-button size="small" class="sort-btn" :class="{ 'is-active': sortOrder === 'asc' }" @click="toggleSort">
              <i :class="sortOrder === 'desc' ? 'el-icon-sort-down' : 'el-icon-sort-up'"></i>
              {{ sortOrder === "desc" ? "最新优先" : "最早优先" }}
            </el-button>
          </div>
        </div>
        <div v-if="newloading" class="loading-container">
          <div class="loading-text">正在加载数据...</div>
        </div>
        <ul class="news_list" v-if="newlist.length > 0 && !newloading">
          <li v-for="(item, index) in newlist" :key="index" class="flex">
            <span class="index">{{ (pageNo - 1) * pageSize + index + 1 }}</span>
            <div class="right-info">
              <p class="title line1" @click="tohref(item.articlelink)">
                <span class="line1" v-html="item.title" :title="item.title"></span>
              </p>
              <p v-if="item.authors">
                作者：<span class="keep-space">{{ item.authors }}</span>
              </p>
              <p v-if="item.journal">期刊：{{ item.journal }}</p>
              <p v-if="item.authors">DOI：{{ item.doi }}</p>
              <p v-if="item.pubdate">出版日期：{{ item.pubdate }}</p>
              <p v-if="item.abstractText" class="line2">摘要：{{ item.abstractText }}</p>
              <p class="pdflink" v-if="item.articlelink || item.pdflink" @click="copyArticleLink(item)">复制全文链接</p>
            </div>
          </li>
        </ul>
        <div class="no-data-container" v-if="newlist.length <= 0 && !newloading">
          <!-- <div class="no-data-text">暂无数据</div> -->
          <el-empty description="暂无数据"></el-empty>
        </div>
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNo" :page-sizes="[10, 20, 30, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" hide-on-single-page> </el-pagination>
      </div>

      <div v-if="activeTab === 1" class="tab-content">
        <div class="content-header" v-if="providedReports.length > 0">
          <h3>最近半年 · 新兴话题月报与周报</h3>
        </div>
        <!-- 加载状态 -->
        <div v-if="loading" class="loading-container">
          <div class="loading-text">正在加载数据...</div>
        </div>
        <!-- 错误状态 -->
        <div v-else-if="error" class="error-container">
          <div class="error-text">{{ error }}</div>
          <el-button type="primary" size="small" @click="fetchNewTopicData">重新加载</el-button>
        </div>
        <!-- 数据展示 -->
        <div v-else-if="providedReports.length > 0">
          <div class="month-section" v-for="(month, pmIndex) in providedReports" :key="`p-` + pmIndex">
            <div class="month-title">{{ month.label }}</div>
            <div class="report-cards">
              <div class="report-card monthly" @click="openReport(month.monthly)" v-if="month.monthly">
                <div class="report-meta">
                  <span class="badge">{{ month.monthly.type || "月报" }}</span>
                </div>
                <div class="report-title">{{ displayMonthlyTitle(month) }}</div>
                <div class="report-desc">{{ month.monthly.desc }}</div>
              </div>

              <div class="report-card weekly" v-for="(week, wIndex) in month.weeklies" :key="wIndex" @click="openReport(week)">
                <div class="report-meta">
                  <span class="badge secondary">{{ week.type || "周报" }}</span>
                </div>
                <div class="report-title">{{ displayWeeklyTitle(week) }}</div>
                <div class="report-desc">{{ week.desc }}</div>
              </div>
            </div>
          </div>
        </div>

        <!-- 无数据状态 -->
        <div v-else class="no-data-container">
          <!-- <div class="no-data-text">暂无数据</div> -->
          <el-empty description="暂无数据"></el-empty>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { EventBus } from "../../utils/eventBus";
import axios from "@/api/axios";
import baseurl from "../../api/baseurl";
export default {
  name: "SubjectGatewayDynamic",
  data() {
    return {
      activeTab: 0,
      tabList: [
        { name: "最新文章", key: "latest" },
        { name: "新兴话题", key: "emerging" },
      ],
      newloading: false,
      loading: false,
      currentYear: new Date().getFullYear(),
      providedReports: [],
      error: null,
      reportBasePath: "",
      subjectname: "",
      newlist: [],
      pageNo: 1,
      pageSize: 10,
      total: 0,
      keyword: "",
      sortOrder: "desc",
    };
  },
  mounted() {
    this.timer = setInterval(() => {
      // 检查是否已通过EventBus加载数据
      if (sessionStorage.getItem("subjectNodes")) {
        let subjectNode = JSON.parse(sessionStorage.getItem("subjectNodes"));
        // 使用英文名称而不是label，确保传参始终为英文
        let subjectValue = subjectNode.name;
        this.getSubjectId(subjectValue);
      }
    }, 300);
    EventBus.$on("SubjectName", name => {
      this.subjectname = name;
      if (this.activeTab === 1) {
        this.fetchNewTopicData(name);
      } else if (this.activeTab === 0) {
        this.fetchNewArticleData();
      }
    });
  },
  methods: {
    getSubjectId(subjectValue) {
      window.clearInterval(this.timer);
      this.subjectname = subjectValue;
      if (this.activeTab === 1) {
        this.fetchNewTopicData();
      } else if (this.activeTab === 0) {
        this.fetchNewArticleData();
      }
    },
    async fetchNewTopicData() {
      try {
        this.loading = true;
        this.error = null;
        // 获取当前学科，可以从路由参数或其他地方获取
        const subject = this.subjectname;
        const response = await axios.post("/api/v1/subject/gateway/newTopic/list", {
          subject: subject,
          type: "weekly",
        });

        if (response.code === 200 && response.data) {
          this.providedReports = response.data;
        } else {
          this.error = response.msg || "获取数据失败";
        }
      } catch (error) {
        this.error = "网络错误，请稍后重试";
      } finally {
        this.loading = false;
      }
    },
    onSearch() {
      this.pageNo = 1;
      this.fetchNewArticleData();
    },
    toggleSort() {
      this.sortOrder = this.sortOrder === "desc" ? "asc" : "desc";
      this.pageNo = 1;
      this.fetchNewArticleData();
    },
    fetchNewArticleData() {
      this.newloading = true;
      let postBody = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        subjects: [this.subjectname],
        keyword: this.keyword || undefined,
        sortOrder: this.sortOrder,
      };
      this.$http({
        url: "/api/v1/subject/gateway/dynamic/lasted",
        method: "post",
        data: postBody,
      })
        .then(res => {
          // 判断返回数量是否等于零
          const recordCount = parseInt(res.data.recordCount) || 0;
          if (recordCount === 0) {
            // 当前学科无结果时尝试父学科下所有子学科兜底（带检索词时同样兜底）
            this.getParentSubjectChildren().then(childrenNames => {
              if (childrenNames && childrenNames.length > 0) {
                postBody.subjects = childrenNames;
                this.$http({
                  url: "/api/v1/subject/gateway/dynamic/lasted",
                  method: "post",
                  data: postBody,
                })
                  .then(retryRes => {
                    this.newloading = false;
                    this.total = parseInt(retryRes.data.recordCount) || 0;
                    this.newlist = retryRes.data.recordList || [];
                  })
                  .catch(() => {
                    this.newloading = false;
                    this.total = 0;
                    this.newlist = [];
                  });
              } else {
                this.newloading = false;
                this.total = recordCount;
                this.newlist = res.data.recordList || [];
              }
            });
          } else {
            this.newloading = false;
            this.total = recordCount;
            this.newlist = res.data.recordList || [];
          }
        })
        .catch(() => {
          this.newloading = false;
          this.total = 0;
          this.newlist = [];
        });
    },
    // 根据当前学科获取父学科下的所有子学科
    getParentSubjectChildren() {
      return new Promise(resolve => {
        // 获取当前学科信息
        const currentSubjectName = this.subjectname;
        if (!currentSubjectName) {
          resolve([]);
          return;
        }

        // 查找父学科的辅助函数
        const findParentSubject = (treeData, subjectName) => {
          if (!treeData || treeData.length === 0) {
            return null;
          }
          for (let i = 0; i < treeData.length; i++) {
            const firstLevel = treeData[i];
            if (firstLevel.childrenList && firstLevel.childrenList.length > 0) {
              const foundChild = firstLevel.childrenList.find(child => child.name === subjectName || child.cnName === subjectName);
              if (foundChild) {
                return firstLevel;
              }
            }
          }
          return null;
        };

        // 获取学科树结构，根据当前学科名称搜索
        this.$http({
          url: `api/v1/subject/gateway/topic/tree?name=${encodeURIComponent(currentSubjectName)}&isZh=true`,
          method: "GET",
        })
          .then(res => {
            let parentSubject = findParentSubject(res.data, currentSubjectName);

            if (parentSubject && parentSubject.childrenList && parentSubject.childrenList.length > 0) {
              // 找到父学科，返回所有子学科的名称
              const childrenNames = parentSubject.childrenList.map(child => child.name || child.cnName);
              resolve(childrenNames);
            } else {
              // 如果通过搜索没找到，尝试获取全部学科树
              this.$http({
                url: "api/v1/subject/gateway/topic/tree?name=&isZh=true",
                method: "GET",
              })
                .then(allRes => {
                  parentSubject = findParentSubject(allRes.data, currentSubjectName);
                  if (parentSubject && parentSubject.childrenList && parentSubject.childrenList.length > 0) {
                    const childrenNames = parentSubject.childrenList.map(child => child.name || child.cnName);
                    resolve(childrenNames);
                  } else {
                    resolve([]);
                  }
                })
                .catch(() => {
                  resolve([]);
                });
            }
          })
          .catch(() => {
            resolve([]);
          });
      });
    },
    handleCurrentChange(val) {
      this.pageNo = val;
      this.fetchNewArticleData();
    },
    handleSizeChange(val) {
      this.pageNo = 1;
      this.pageSize = val;
      this.fetchNewArticleData();
    },
    switchTab(index) {
      this.activeTab = index;
      if (this.activeTab === 1) {
        this.fetchNewTopicData();
      } else if (this.activeTab === 0) {
        this.pageNo = 1;
        this.keyword = "";
        this.sortOrder = "desc";
        this.fetchNewArticleData();
      }
    },
    copyArticleLink(item) {
      const link = item.articlelink || item.pdflink;
      if (!link) {
        this.$message.info("暂无对应链接");
        return;
      }
      this.copyTextToClipboard(link);
    },
    copyTextToClipboard(text) {
      const fallbackCopy = () => {
        try {
          const textarea = document.createElement("textarea");
          textarea.style.position = "fixed";
          textarea.style.opacity = "0";
          textarea.value = text;
          document.body.appendChild(textarea);
          textarea.focus();
          textarea.select();
          const successful = document.execCommand("copy");
          document.body.removeChild(textarea);
          if (successful) {
            this.$message.success("全文链接已复制");
          } else {
            this.$message.error("复制失败，请手动复制");
          }
        } catch (error) {
          this.$message.error("复制失败，请手动复制");
        }
      };

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard
          .writeText(text)
          .then(() => {
            this.$message.success("全文链接已复制");
          })
          .catch(() => {
            fallbackCopy();
          });
      } else {
        fallbackCopy();
      }
    },

    tohref(href) {
      if (href) {
        // 直接使用接口返回的完整路径
        window.open(href, "_self");
        return;
      }
      this.$message.info("暂无对应数据");
    },
    formatWeekLabel(year, weekOfYear) {
      const w = String(weekOfYear).padStart(2, "0");
      return `${year}年第${w}周`;
    },
    displayMonthlyTitle(month) {
      // 直接返回接口返回的标题
      return month.monthly && month.monthly.title ? month.monthly.title : "";
    },
    displayWeeklyTitle(week) {
      // 直接返回接口返回的标题
      return week && week.title ? week.title : "";
    },
    openReport(report) {
      // 如果有文件路径，构建完整URL
      if (report && report.file) {
        let routeUrl;
        if (window.__POWERED_BY_QIANKUN__) {
          routeUrl = baseurl.fileUrl + this.reportBasePath + report.file;
        } else {
          routeUrl = this.reportBasePath + report.file;
        }
        window.open(routeUrl, "_blank");
      } else {
        this.$message.info("暂无对应报告文件");
      }
    },
  },
};
</script>

<style scoped lang="scss">
.dynamic-container {
  min-height: 100vh;
  background: #f5f7fa;
  padding: 20px 0;
}

.w1300 {
  width: 1300px;
  margin: 0 auto;
}

.dynamic-header {
  text-align: center;
  margin-bottom: 20px;

  h2 {
    font-size: 28px;
    color: #2c5f97;
    margin-bottom: 10px;
  }
}

.dynamic-tabs {
  display: flex;
  background: white;
  border-radius: 8px;
  padding: 5px;
  margin-bottom: 20px;
  // box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

  .tab-item {
    flex: 1;
    text-align: center;
    padding: 15px 20px;
    cursor: pointer;
    border-radius: 6px;
    transition: all 0.3s ease;
    font-weight: 500;

    &:hover {
      background: #f0f7ff;
      color: #2c5f97;
    }

    &.active {
      background: #2c5f97;
      color: white;
    }
  }
}

.tab-content {
  background: white;
  border-radius: 8px;
  padding: 20px;
  // box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.content-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  h3 {
    color: #2c5f97;
    margin: 0;
  }
}

.month-section {
  margin-bottom: 22px;
}

.month-title {
  font-weight: 600;
  color: #2c5f97;
  margin: 10px 0 12px;
}

.report-cards {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
}

.report-card {
  border: 1px solid #eee;
  border-radius: 8px;
  padding: 14px;
  background: #fff;
  transition: box-shadow 0.2s ease, border-color 0.2s ease;
  cursor: pointer;
  &:hover {
    border-color: #2c5f97;
    box-shadow: 0 4px 12px rgba(44, 95, 151, 0.08);
  }

  &.monthly {
    border-left: 4px solid #4ecdc4;
  }
  &.weekly {
    border-left: 4px solid #63ace5;
  }

  .report-meta {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
    .badge {
      background: #4ecdc4;
      color: #fff;
      padding: 2px 8px;
      border-radius: 10px;
      font-size: 12px;
      &.secondary {
        background: #63ace5;
      }
    }
    .date {
      color: #888;
      font-size: 12px;
    }
  }

  .report-title {
    font-size: 16px;
    color: #2c5f97;
    margin-bottom: 6px;
  }
  .report-desc {
    color: #666;
    font-size: 13px;
  }
}

.article-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
  gap: 12px;

  .total {
    margin: 0;
    white-space: nowrap;
    flex-shrink: 0;

    &.placeholder {
      min-width: 1px;
    }
  }

  .toolbar-right {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;

    .search-input {
      width: 448px; /* 280 * 1.6 */
    }

    .sort-btn {
      white-space: nowrap;
      color: #606266;
      border-color: #dcdfe6;
      background: #fff;

      &:hover {
        color: #2c5f97;
        border-color: #2c5f97;
      }

      &.is-active {
        color: #2c5f97;
        border-color: #2c5f97;
        background: #f0f7ff;
      }
    }
  }
}

// 状态容器样式
.loading-container,
.error-container,
.no-data-container {
  text-align: center;
  padding: 40px 20px;
}

.loading-text,
.error-text,
.no-data-text {
  color: #666;
  font-size: 16px;
  margin-bottom: 20px;
}

.error-container {
  .error-text {
    color: #f56c6c;
    margin-bottom: 15px;
  }
}

@media (max-width: 1300px) {
  .w1300 {
    width: 100%;
  }
}
.total {
  color: #86909c;
  span {
    color: #ff0000;
    margin-right: 5px;
  }
}
.news_list {
  li {
    padding: 20px 0;
    border-bottom: 1px dashed #eeeeee;
    .title {
      color: #333;
      font-size: 18px;
      font-weight: bold;
      margin-bottom: 10px;
      cursor: pointer;
      &:hover {
        color: #2c5f97;
      }
    }
    p {
      line-height: 30px;
      color: #666666;
    }
    .pdflink {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      padding: 5px 18px;
      background: #e6f7ff;
      color: #2c5f97;
      border-radius: 5px;
      margin-top: 10px;
      cursor: pointer;
      white-space: nowrap;
      border: 1px solid transparent;
      transition: all 0.2s ease;
      &:hover {
        border-color: #2c5f97;
        background: #f0fbff;
      }
    }
  }
  .keep-space {
    white-space: pre-wrap;
  }
  .index {
    width: 50px;
    line-height: 30px;
  }
  .right-info {
    flex: 1;
    max-width: 1180px;
  }
}
</style>
